module.exports = {"sld:ColorMapEntry":[{"quantity":-999,"color":"#FFFFFF","label":"NO DATA"},{"quantity":0,"color":"#D7D7D7","label":"0"},{"quantity":0.001,"color":"#198CDB","label":"<=0.56"},{"quantity":0.03,"color":"#91E3AD","label":"0.56 - 1.39"},{"quantity":0.06,"color":"#DEFFB0","label":"1.39 - 2.46"},{"quantity":0.1,"color":"#FFE68C","label":"2.46 - 3.88"},{"quantity":9,"color":"#FF9982","label":"3.88 - 5.81"},{"quantity":12,"color":"#FF4D30","label":"5.81 - 11.15"}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/county_maize_wheat_rice_mme_1981_2016_lcr_80_wheat.json
// module id = 1RLQ
// module chunks = 171